import { Collection } from 'caldera-immutable-model';

import Collaborator from './Collaborator';

import type { Id } from '../redux/types';

export default class CollaboratorCollection extends Collection {
  static Model = Collaborator;

  removeByUser(user: Id): CollaboratorCollection {
    return this.remove(c => c.user !== user);
  }

  findByUser(user: Id): CollaboratorCollection {
    return this.find(c => c.user === user);
  }
}



// WEBPACK FOOTER //
// ./src/models/CollaboratorCollection.js